export default{	
	userIsLogged(state){
		return state.token;
	},
	user: state => (state.user || JSON.parse(localStorage.getItem('user') || '{}')),
	userFavorite(state){
		return state.userFavorite;
	},
}